/* eslint-disable max-statements */
import { Calendar } from 'primereact/calendar';
import { TabPanel, TabView } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useRef, useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useParams } from 'react-router-dom';
import { Tooltip } from 'primereact/tooltip';
import { useSelector } from 'react-redux';

import '../../pages/edsDashboard/edsDashboard.scss';
import { AssociateLookup } from '../filters/associateLookup/AssociateLookup';
import { ScorecardFilter } from '../filters/scorecardFilter/ScorecardFilter';
import './scoreCardFilter.scss';
import { selectCurrentEmpid, selectCurrentRole } from '../../pages/login/authSlice';
import { useGetScorecardFilterByRoleQuery, useGetScorecardFilterQuery } from './scoreCardFilterSlice';
import { MANAGERROLE, SUPERVISORROLE } from '../../constants';
import { ConstApplicationRole } from '../../utils/typeConstants';
import { LoadingSpinner } from '../loadingSpinner/loadingspinner';
import { saveSCfilDate, loadSCfilDate } from '../../utils/dateStorage';

type scorecardFilterProps = {
    menuName: string;
    agentNumber?: React.Dispatch<any>;
    scorecardData: (value: any) => void;
    agentName?: (e: any) => void;
    filterSCValue: React.Dispatch<any>;
    filterSCName?: React.Dispatch<any>;
    filterMonth: React.Dispatch<any>;
    filterYear: React.Dispatch<any>;
    myScoreCards?: boolean;
    filterDisabled?: boolean;
    isEmpDimensionsHistory?: boolean;
    scorecardId?: React.Dispatch<any>;
    parentClientId?: React.Dispatch<any>;
    recalcutionTab?: string;
    edsActiveIndex?: number;
};
type ScorecardOption = {
    scorecard_version_id: number;
    scorecard_name: string;
    scorecard_id: string;
};


export const ScoreCardFilter = ({
    menuName,
    agentNumber,
    scorecardData,
    agentName,
    filterSCValue,
    filterSCName,
    filterMonth,
    filterYear,
    myScoreCards = false,
    filterDisabled = false,
    isEmpDimensionsHistory = false,
    scorecardId,
    parentClientId,
    recalcutionTab = '',
    edsActiveIndex = 0,
}: scorecardFilterProps) => {
    const [date, setDate] = useState(new Date());
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [selectedScorecard, setSelectedScorecard] = useState<number | string>('');
    const [selectedScorecardName, setSelectedScorecardName] = useState('');
    const [disablefilterMenu1, setDisablefilterMenu1] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [inputScorecardVersion, setInputScorecardVersion] = useState<number | string>('');

    const [scorecardOptions, setScorecardOptions] = useState<ScorecardOption[]>([]);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedRole = useSelector(selectCurrentRole);
    const [dimensionsData, setDimensionsData] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);

    const toast = useRef<Toast>(null);
    const { tldate } = useParams();
    const roleValue = React.useMemo(() => {
        if (loggedRole === MANAGERROLE) return ConstApplicationRole.MANAGER;
        if (loggedRole === SUPERVISORROLE) return ConstApplicationRole.TEAM_LEAD;
        return 0;
    }, [loggedRole]);
    const { data: scorecardFilterDataByRole, isFetching: scorecardRoleDataFetching } = useGetScorecardFilterByRoleQuery(
        {
            employeenumber: loggedEmpNum,
            applicationRoleId: roleValue,
            year: inputYear,
            month: inputMonth,
        },
        {
            skip: !inputMonth || !inputYear || disablefilterMenu1 === false,
        }
    );
    const { data: scorecardFilterData, isFetching: scorecardFetching } = useGetScorecardFilterQuery({
        year: inputYear,
        month: inputMonth,
        parentClientId: dimensionsData?.parentClientId,
        clientId: dimensionsData?.clientId,
        programId: dimensionsData?.programId,
        projectId: dimensionsData?.projectId,
        countryId: dimensionsData?.countryId,
        geolocationId: dimensionsData?.geolocationId,
    });

    const DateOnChange = (e: any) => {
        if (!(e.value instanceof Date) || isNaN(e.value.getTime())) return;
        setDate(e.value);
        setMonth(e.value.getMonth() + 1);
        setYear(e.value.getFullYear());
        saveSCfilDate(e.value);
    };
    useEffect(() => {
        if (
            scorecardFetching ||
            scorecardRoleDataFetching
        ) {
            setLoading(true);
        } else setLoading(false);
    }, [
        scorecardFetching,
        scorecardRoleDataFetching,
    ]);

    useEffect(() => {
        if (scorecardFilterDataByRole?.data && scorecardFilterDataByRole?.data?.length > 0)
            setScorecardOptions(scorecardFilterDataByRole?.data);
        else if (!disablefilterMenu1)
            setScorecardOptions(scorecardFilterData?.data || []);
    }, [scorecardFilterDataByRole, scorecardFilterData]);
    useEffect(() => {
        let scorecardAPIData = null;
        if (activeIndex === 1)
            scorecardAPIData = scorecardOptions;
        else if (disablefilterMenu1 === true) {
            scorecardAPIData = scorecardFilterDataByRole?.data;
        }
        else
            scorecardAPIData = scorecardFilterData?.data;
        if (scorecardAPIData?.length > 0) {
            setScorecardOptions(scorecardAPIData);
            const filterScorecard = scorecardAPIData?.filter(
                (item: any) =>
                    item.scorecard_version_id === parseInt(window.localStorage.ScFilDdlScorecard, 10)
            );
            if (filterScorecard.length > 0) {
                setSelectedScorecard(parseInt(window.localStorage.ScFilDdlScorecard, 10));
                setSelectedScorecardName(window.localStorage.ScFilDdlScorecardName);
            } else {
                if (disablefilterMenu1 && window.localStorage.ScFilDdlScorecard) {
                    window.localStorage.ScFilDdlScorecard = '';
                    window.localStorage.ScFilDdlScorecardName = '';
                    //toast.error('Scorecard filter is reset');
                }
                setSelectedScorecard(0);
                setSelectedScorecardName('');
            }
        } else {
            setScorecardOptions([]);
            setSelectedScorecard(0);
            setSelectedScorecardName('');
            scorecardData('');
        }
    }, [scorecardFilterData, disablefilterMenu1, scorecardFilterDataByRole, inputMonth]);
    const resetAllFilters = () => {
        scorecardData('');
        setSelectedScorecard('');
        setSelectedScorecardName('');
        setInputScorecardVersion('');

        const today = new Date();
        setDate(today);
        setMonth(today.getMonth() + 1);
        setYear(today.getFullYear());

        if (scorecardFilterDataByRole?.data && scorecardFilterDataByRole?.data?.length > 0)
            setScorecardOptions(scorecardFilterDataByRole?.data);
        else
            setScorecardOptions(scorecardFilterData?.data || []);
    };
    useEffect(() => {
        setSelectedScorecard('');
        setSelectedScorecardName('');
        setInputScorecardVersion('');
        if (activeIndex === 1) {
            setDimensionsData({});
        }
        else if (activeIndex === 0 && window.localStorage.ScFilDdlParClient)
            setDimensionsData((prev: any) => ({
                ...prev,
                parentClientId: parseInt(window.localStorage.ScFilDdlParClient, 10),
            }));
    }, [activeIndex])
    useEffect(() => {
        filterMonth(inputMonth);
        filterSCValue(selectedScorecard);
        filterYear(inputYear);
        if (filterSCName) {
            filterSCName(selectedScorecardName);
        }
    }, [selectedScorecard, inputMonth, inputYear, selectedScorecardName]);

    useEffect(() => {
        if (tldate) {
            const storedDate = new Date(tldate);
            if (!isNaN(storedDate.getTime())) {
                setDate(storedDate);
                setMonth(storedDate.getMonth() + 1);
                setYear(storedDate.getFullYear());
                saveSCfilDate(storedDate);
            }
        } else {
            const storedDate = loadSCfilDate();
            if (storedDate) {
                setDate(storedDate);
                setMonth(storedDate.getMonth() + 1);
                setYear(storedDate.getFullYear());
            }
        }
    }, []);

    useEffect(() => {
        if (myScoreCards === true) {
            filterSCValue(0);
            setDisablefilterMenu1(true);
        } else {
            setDisablefilterMenu1(false);
            filterSCValue(selectedScorecard);
        }
    }, [myScoreCards]);

    useEffect(() => {
        if (isEmpDimensionsHistory) setActiveIndex(1);
        else setActiveIndex(0);
    }, [isEmpDimensionsHistory]);

    useEffect(() => {
        if (edsActiveIndex === 9) {
            if (recalcutionTab === 'associate') setActiveIndex(1);
            else setActiveIndex(0);
        }
    }, [recalcutionTab, edsActiveIndex]);
    const handleScorecardChange = (e: any) => {
        const selectedId = e.value;
        const selectedItem = scorecardOptions.find(
            (item: any) => item?.scorecard_version_id === selectedId
        );
        const scname = selectedItem?.scorecard_name;
        const scId = selectedItem?.scorecard_id ?? 0;
        setSelectedScorecard(selectedId);

        window.localStorage.setItem('ScFilDdlScorecard', selectedId);
        window.localStorage.setItem('ScFilDdlScorecardName', scname ?? '');

        if (selectedItem?.scorecard_id) {
            window.localStorage.setItem('ScFilDdlScorecardId', selectedItem.scorecard_id);
        }

        setInputScorecardVersion(e.value);
        if (scorecardId) {
            scorecardId(scId);
        }
        scorecardData({
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: e.value,
            currentDate: date,
            scorecardName: selectedItem?.scorecard_name,
            scorecardId: selectedItem?.scorecard_id,
        });
    };
    return (
        <div className='shadow card bg-body rounded border-0 mt-3'>
            <Toast ref={toast} />
            <div className="tabview-demo border-0 scorecardReverseFilter">
                <div className="card border-0 mt-2">
                    <div className='row mt-2 ms-2'>
                        <div className='col-md-3 mt-1'>
                            <h6>Month</h6>
                            <Calendar
                                value={date}
                                onChange={DateOnChange}
                                view="month"
                                maxDate={new Date()}
                                showIcon
                                className="custom-calendar mt-1"
                                dateFormat="MM, yy" 
                                // style={{ borderRadius: '20px', width: '100%' }}
                            />
                        </div>
                        <div className='col-md-3'>
                            <h6 style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                Scorecard
                                <Tooltip target=".help-circle" position="right" />
                                <span className="help-circle" data-pr-tooltip={'After selecting a filter, you will be able to see available scorecards in this dropdown.'}>
                                    <i className="pi pi-question" style={{ color: 'white' }} />
                                </span>
                            </h6>

                            <Dropdown
                                style={{ borderRadius: '20px', width: '100%' }}
                                value={selectedScorecard}
                                options={scorecardOptions}
                                onChange={handleScorecardChange}
                                optionLabel="scorecard_name"
                                optionValue="scorecard_version_id"
                                placeholder="Select Scorecard"
                                className="custom-dropdown"
                            />
                        </div>
                    </div>
                    <span>{loading ? <LoadingSpinner /> : ''}</span>
                    <Accordion id="ScorecardFilter" style={{ margin: '20px', borderRadius: '10px' }}>
                        <AccordionTab header="Scorecard Filters">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    setActiveIndex(e.index);
                                }}
                            >
                                <TabPanel
                                    header="Scorecard"
                                    disabled={
                                        isEmpDimensionsHistory ||
                                        (edsActiveIndex === 9 && recalcutionTab === 'associate')
                                    }
                                >
                                    <ScorecardFilter
                                        filterDisabled={filterDisabled}
                                        scorecardData={scorecardData}
                                        ipInputMonth={inputMonth}
                                        ipInputYear={inputYear}
                                        ipSetInputScorecard={setSelectedScorecard}
                                        resetDate={resetAllFilters}
                                        disablefilterMenu1={disablefilterMenu1}
                                        setParentClientId={parentClientId}
                                        inputScorecardVersion={inputScorecardVersion}
                                        setDimensionsData={setDimensionsData}
                                        setInputScorecardVersion={setInputScorecardVersion}
                                    />
                                </TabPanel>
                                <TabPanel
                                    header="Associate"
                                    disabled={edsActiveIndex === 9 && recalcutionTab === 'scorecard'}
                                >
                                    <AssociateLookup
                                        filterDisabled={filterDisabled}
                                        setAgentNumber={agentNumber}
                                        setAgentName={agentName}
                                        menuName={menuName}
                                        ipInputMonth={inputMonth}
                                        ipInputYear={inputYear}
                                        ipSetInputScorecard={setSelectedScorecard}
                                        resetDate={resetAllFilters}
                                        setScorecardOptions={setScorecardOptions}
                                        setInputScorecardVersion={setInputScorecardVersion}
                                    />
                                </TabPanel>
                            </TabView></AccordionTab>
                    </Accordion>
                </div>
            </div>
        </div>
    );
};
